import { useEffect, useState } from "react"
import { AuthError, LoadingPage, UserNotFound } from "@components"
import { decodeToken } from "@helpers"
import { authService } from "@services"
import { useLocation } from "react-router-dom"

const Login = () => {
  const location = useLocation()
  const [error, setError] = useState(false)
  const [showUserNotFound, setShowUserNotFound] = useState(false)

  useEffect(() => {
    authService.clearToken()
    authService.clearApolloCache()
  }, [])

  useEffect(() => {
    setError(false)
    setShowUserNotFound(false)

    const queryParams = new URLSearchParams(location.search)
    const token = queryParams.get("token")

    if (!token) {
      setError(true)
      return
    }

    const decodedToken = decodeToken(token)

    if (!decodedToken) {
      setError(true)
      return
    }

    // Case 1: status exists and is USER_NOT_FOUND
    if (decodedToken.status === "USER_NOT_FOUND") {
      setShowUserNotFound(true)
      return
    }

    // Case 2: no status (or status is something else) => proceed to verify
    sessionStorage.setItem("adminToken", token)
    window.location.replace("/verify")
  }, [location.search])

  if (error) {
    return <AuthError />
  }

  if (showUserNotFound) {
    return <UserNotFound />
  }

  return <LoadingPage message="Checking user credentials..." />
}

export default Login